export const testimonialList = [
  {
    name: "林一诺",
    role: "内容运营 · 三年老读者",
    initial: "林",
    content:
      "每天早上打开瓜点看一遍今日榜首，基本上当天办公室聊的话题就全掌握了。榜单分层做得很清楚，爆发和持续热度一眼能分开。",
  },
  {
    name: "陈牧",
    role: "自媒体创作者",
    initial: "陈",
    content:
      "最实用的是它会把多方说法整理在一起，而不是只放一个标题。做选题的时候直接看关键信息那一段就够了，省掉大量翻资料的时间。",
  },
  {
    name: "周知遥",
    role: "学生党",
    initial: "周",
    content:
      "界面看着舒服，广告少，翻起来不累。分类做得很细，我一般只逛影视综艺和游戏电竞这两块，也不会有乱七八糟的推荐。",
  },
  {
    name: "何雨桐",
    role: "品牌公关",
    initial: "何",
    content:
      "危机监测的时候会用它看热度走势。虽然不提供专业报告，但今日榜和本周榜的对比足够让我判断一件事是在发酵还是在降温。",
  },
];